var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.css }, [
    _c("div", { staticClass: "swiper" }, [
      _c(
        "div",
        { staticClass: "swiper-wrapper" },
        _vm._l(_vm.items, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "swiper-slide",
              attrs: { "data-index": index },
            },
            [
              _c("hero-homepage-picture", {
                attrs: {
                  active: index === _vm.activeIndex,
                  translations: _vm.translations,
                  "desktop-sizes": _vm.desktopSizes,
                  item: item,
                  "mobile-sizes": _vm.mobileSizes,
                  "is-mobile": _vm.isSmallDevice,
                  main: index === 0,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "hero-homepage__container" },
                [
                  _c("hero-homepage-content", {
                    attrs: {
                      "cta-link-class": item.cta_link_class,
                      item: item,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "swiper-controls" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showNavigationButtons,
                expression: "showNavigationButtons",
              },
            ],
            staticClass: "swiper-controls-button swiper-button-prev",
            on: { click: _vm.previousSlide },
          },
          [_c("hero-homepage-arrow", { attrs: { direction: "left" } })],
          1
        ),
        _vm._v(" "),
        _c("div", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showNavigationButtons,
              expression: "showNavigationButtons",
            },
          ],
          staticClass: "swiper-controls-pagination swiper-pagination",
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showNavigationButtons,
                expression: "showNavigationButtons",
              },
            ],
            staticClass: "swiper-controls-button swiper-button-next",
            on: { click: _vm.nextSlide },
          },
          [_c("hero-homepage-arrow", { attrs: { direction: "right" } })],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }